//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Assemblies/Assemblies.SelectComponentList.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/SelectFaceList.js";
import "../Tooling/Tooling.ShimInnerProfileSetBuilderList.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"Height",0,"Expression",0],[1,"InsertToDelete",0,"Assemblies.SelectComponentList",0],[1,"InsertToEdit",0,"Assemblies.SelectComponent",0],[1,"OffsetOuterDistance",0,"Expression",0],[0,"OuterRoughOffset",1,0],[0,"ParentNode",1,0],[0,"ParentPartName",1,0],[0,"RenameToggle",1,0],[1,"ShimFace",0,"SelectFaceList",0],[0,"SideAttributeValue",1,0],[1,"SlugholeProfile",0,"Tooling.ShimInnerProfileSetBuilderList",0],[0,"Type",1,0],[0,"WizardType",1,0]],[[[],"CreateInnerProfileSetBuilder",{R_:{innerProfileBuilder:"Tooling.ShimInnerProfileSetBuilder"}},0,0],[["numName","itemName"],"GetItemName",{},0,0],[["itemName"],"SetItemName",{},1,0]],[]];
SPLM.Tooling.ShimBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ShimBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ShimBuilder.Types = Object.freeze({
    "AddInsert" : "AddInsert", "EditInsert" : "EditInsert", "DeleteInsert" : "DeleteInsert"});

SPLM.Tooling.ShimBuilder.ParentOption = Object.freeze({
    "NoParent" : "NoParent"});

SPLM.Tooling.ShimBuilder.SideAttributeValues = Object.freeze({
    "None" : "None", "Top" : "Top", "Middle" : "Middle", "Bottom" : "Bottom"});

export default SPLM;